module.exports = __webpack_public_path__ + "img/4.599b9bc5.png";